import { useState } from 'react'

export const useDragControls = (scrollRef, pauseAnimation, resumeAnimation) => {
  const [isDragging, setIsDragging] = useState(false)
  const [dragStart, setDragStart] = useState({ x: 0, scrollLeft: 0 })

  const handleMouseDown = (e) => {
    pauseAnimation()
    setIsDragging(true)

    const scrollContainer = scrollRef.current
    if (scrollContainer) {
      setDragStart({
        x: e.pageX - scrollContainer.offsetLeft,
        scrollLeft: scrollContainer.scrollLeft
      })
    }
  }

  const handleMouseMove = (e) => {
    if (!isDragging || !scrollRef.current) return

    e.preventDefault()
    const scrollContainer = scrollRef.current
    const x = e.pageX - scrollContainer.offsetLeft
    const walk = (x - dragStart.x) * 2 // Multiply for faster scroll
    scrollContainer.scrollLeft = dragStart.scrollLeft - walk
  }

  const handleMouseUp = () => {
    resumeAnimation()
    setIsDragging(false)
  }

  return {
    isDragging,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp
  }
}